module.exports = __webpack_public_path__ + "static/media/808ColumnLabel--13.ae60504e.svg";